import * as api from '@/api/signin'
import Signin from '@/store/models/signin'

export let state = {
  signin: new Signin,
  signins: {
    data: []
  }
}

export let mutations = {
  setSignins: (state, payload) => state.signins = payload,

  reset: state => state.signin = new Signin,
  setSignin: (state, payload) => state.signin = (new Signin).hydrate(payload),
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setSignins', response.data)
      resolve()
    }, reject)
  }),

  remove: ({ }, signin) => new Promise((resolve, reject) => {
    api.remove(signin.id, resolve, reject)
  }),

  removeAll: ({ commit }) => new Promise((resolve, reject) => {
    api.removeAll(response => {
      commit('setSignins', response.data)
      resolve()
    }, reject)
  }),

  downloadAll: ({ }) => new Promise((resolve, reject) => {
    api.downloadAll(response => {
      resolve(response.data)
    }, reject)
  })

}